import { getApi, postApi, putApi } from "../apiCall";

// --------- Banking Creation & Update ---------

export const createBankingList = (data, companyId, userId) => {
  const url = `${process.env.REACT_APP_API_URL}/banking/create`;
  const headers = {
    "Content-Type": "application/json",
    companyId,
    userId,
  };
  return postApi(url, data, headers);
};

export const updateBankingListing = (payload) => {
  const url = `${process.env.REACT_APP_API_URL}/banking/update`;
  return putApi(url, payload);
};

// --------- Banking Lists & Fetches ---------

export const getBankingPlaced = (
  id,
  currentPage = 0,
  size = 10,
  isInitiator
) => {
  const url = `${process.env.REACT_APP_API_URL}/banking/bid/list?id=${id}&currentPage=${currentPage}&size=${size}&isInitiator=${isInitiator}`;
  return getApi(url);
};

export const getBankingReceived = (
  id,
  currentPage = 0,
  size = 10,
  isInitiator
) => {
  const url = `${process.env.REACT_APP_API_URL}/banking/bid/listAll?id=${id}&currentPage=${currentPage}&size=${size}&isInitiator=${isInitiator}`;
  return getApi(url);
};

export const getBankingIndents = (id) => {
  const url = `${process.env.REACT_APP_API_URL}/banking/getIntent?id=${id}`;
  return getApi(url);
};

export const getActiveLedger = (
  currentPage = 0,
  size = 10,
  bankingListingId = null
) => {
  let url = `${process.env.REACT_APP_API_URL}/banking/connection/list?currentPage=${currentPage}&size=${size}`;

  if (bankingListingId !== null) {
    url += `&bankingListingId=${bankingListingId}`;
  }

  return getApi(url);
};

export const getArchiveList = (
  currentPage = 0,
  size = 10,
  bankingListingId = null,
  status = null
) => {
  let url = `${process.env.REACT_APP_API_URL}/banking/connection/by-status?listingId=${bankingListingId}`;

  if (status) {
    url += `&status=${status}`;
  }

  return getApi(url);
};

export const getWithdrawnArchive = (
  currentPage = 0,
  size = 10,
  bankingListingId = null,
  status = "INITIATED"
) => {
  const url = `${process.env.REACT_APP_API_URL}/banking/connection/in-active?listingId=${bankingListingId}&connectionStatus=${status}`;
  return getApi(url);
};

export const getArchiveConnectionList = (
  currentPage = 0,
  size = 10,
  bankingListingId = null,
  status
) => {
  const url = `${
    process.env.REACT_APP_API_URL
  }/banking/connections/archive?listingId=${bankingListingId}&connectionStatus=${status}&page=${currentPage}&size=${size}`;

  return getApi(url);
};


export const getLedgerBanking = (currentPage = 0, size = 10) => {
  const url = `${process.env.REACT_APP_API_URL}/banking/connection/list?currentPage=${currentPage}&size=${size}`;
  return getApi(url);
};

export const getLedgerOngoing = (currentPage = 0, size = 10) => {
  const url = `${process.env.REACT_APP_API_URL}/banking/connection/ongoing/list?currentPage=${currentPage}&size=${size}`;
  return getApi(url);
};

export const getAllBankingListing = () => {
  const url = `${process.env.REACT_APP_API_URL}/banking/list?currentPage=0&size=1000`;
  return getApi(url);
};

export const closeBankingListing = (id) => {
  const url = `${process.env.REACT_APP_API_URL}/banking/closeListing/${id}`;
  return putApi(url);
};

export const connectionClose = (connectionId) => {
  const url = `${process.env.REACT_APP_API_URL}/banking/connection/close/${connectionId}`;
  return putApi(url);
};

export const getInterestedCompanies = (
  listingId,
  currentPage = 0,
  size = 10
) => {
  const url = `${process.env.REACT_APP_API_URL}/banking/interestedListings?listingId=${listingId}&currentPage=${currentPage}&size=${size}`;
  return getApi(url);
};

export const getConnectionHistory = (listingId) => {
  const url = `${process.env.REACT_APP_API_URL}/banking/connection-history/${listingId}`;
  return getApi(url);
};

export const getInjectDrawalQuantity = (listingId) => {
  const url = `${process.env.REACT_APP_API_URL}/banking/averageInjectAndDrawl/${listingId}`;
  return getApi(url);
};

// --------- Search & Matchmaking ---------

export const getSearchBanking = (current = true) => {
  const url = `${process.env.REACT_APP_API_URL}/banking/getOthers?current=${current}`;
  return postApi(url);
};

export const getMatchmakingResults = (
  id,
  currentPage = 0,
  size = 1000,
  requestBody = null,
  statusFilter = null
) => {
  let url = `${process.env.REACT_APP_API_URL}/banking/matches?id=${id}&currentPage=${currentPage}&size=${size}`;

  if (statusFilter && statusFilter !== "ALL") {
    url += `&status=${statusFilter}`;
  }

  return getApi(url, requestBody);
};

// --------- Bids ---------

export const placeBid = (payload) => {
  const url = `${process.env.REACT_APP_API_URL}/banking/bid/create`;
  return postApi(url, payload);
};

export const acceptBidTerms = (payload) => {
  const url = `${process.env.REACT_APP_API_URL}/banking/acceptRejectBidTerms`;
  return putApi(url, payload);
};

// --------- Connection & Agreement Updates ---------

export const updateStatusConnection = (connectionId, isApproving) => {
  const url = `${process.env.REACT_APP_API_URL}/banking/approvereject?connectionId=${connectionId}&isApproving=${isApproving}`;
  return putApi(url);
};

export const withdrawListing = (listingId) => {
  const url = `${process.env.REACT_APP_API_URL}/banking/withdraw/${listingId}`;
  return putApi(url);
};

export const holdListing = (listingId) => {
  const url = `${process.env.REACT_APP_API_URL}/banking/hold/${listingId}`;
  return putApi(url, {});
};

export const unHoldListing = (listingId) => {
  const url = `${process.env.REACT_APP_API_URL}/banking/unhold/${listingId}`;
  return putApi(url, {});
};

export const withdrawBid = (bidId) => {
  const url = `${process.env.REACT_APP_API_URL}/banking/bid/withdraw/${bidId}`;
  return putApi(url);
};

export const acceptRejectAgreement = (connectionId, isApproving) => {
  const url = `${process.env.REACT_APP_API_URL}/banking/approveRejectAgreement?connectionId=${connectionId}&isApproving=${isApproving}`;
  return putApi(url);
};

// --------- Ledger Management ---------

export const createLedger = (data) => {
  const url = `${process.env.REACT_APP_API_URL}/banking/ledger/create`;
  const headers = { "Content-Type": "application/json" };
  return postApi(url, data, headers);
};

export const acceptRejectLedger = (ledgerId, isApproving) => {
  const url = `${process.env.REACT_APP_API_URL}/banking/approveRejectLedger?ledgerId=${ledgerId}&isApproving=${isApproving}`;
  return putApi(url);
};

export const downloadListing = (id) => {
  const url = `${process.env.REACT_APP_API_URL}/doc/generate/listing/PDF/BANKING/${id}`;
  return postApi(url, {}, {}, false, "blob");
};

export const updateLedger = (data) => {
  const url = `${process.env.REACT_APP_API_URL}/banking/ledger/update`;
  const headers = { "Content-Type": "application/json" };
  return putApi(url, data, headers);
};

// --------- Document Generation ---------

export const generateLoaDocument = (connectionId) => {
  const url = `${process.env.REACT_APP_API_URL}/doc/generate/loa/WORD/BANKING/${connectionId}`;
  return postApi(url, {}, {}, false, "blob");
};

export const generateLoiDocument = (connectionId) => {
  const url = `${process.env.REACT_APP_API_URL}/doc/generate/loi/WORD/BANKING/${connectionId}`;
  return postApi(url, {}, {}, false, "blob");
};

export const generateFaDocument = (connectionId) => {
  const url = `${process.env.REACT_APP_API_URL}/doc/generate/agreement/EXCEL/BANKING/${connectionId}`;
  return postApi(url, {}, {}, false, "blob");
};

// --------- Document Upload ---------

export const uploadFile = (
  type,
  formData,
  connectionId,
  listingId,
  comment
) => {
  let url = `${process.env.REACT_APP_API_URL}/doc/upload/${type}/BANKING/${connectionId}?listingId=${listingId}`;
  if (comment) {
    url += `&comment=${comment}`;
  }
  return postApi(url, formData, { isFileUpload: true });
};

export const uploadLedgerFile = (formData, connectionId, listingId, comment) =>
  uploadFile("random", formData, connectionId, listingId, comment);

export const uploadLoiFile = (formData, connectionId, listingId) =>
  uploadFile("loi", formData, connectionId, listingId);

export const uploadLoaFile = (formData, connectionId, listingId) =>
  uploadFile("loa", formData, connectionId, listingId);

export const uploadFaFile = (formData, connectionId, listingId) =>
  uploadFile("agreement", formData, connectionId, listingId);

export const uploadTC = (formData) => {
  const url = `${process.env.REACT_APP_API_URL}/doc/upload/termsDocument/BANKING`;
  return postApi(url, formData, { isFileUpload: true });
};

// --------- Document Access ---------

export const getDocumentUrlByLedgerId = (ledgerDocumentId) => {
  const url = `${process.env.REACT_APP_API_URL}/doc/file/url/${ledgerDocumentId}`;
  return getApi(url);
};

// Update downloadView to force blob response
export const downloadView = (ledgerDocumentId) => {
  const url = `${process.env.REACT_APP_API_URL}/doc/file/data/${ledgerDocumentId}`;
  return getApi(url, {
    responseType: "blob",
    headers: {
      Accept: "application/pdf, */*",
    },
  });
};

export const getDocumentHistory = (connectionId, documentType) => {
  const url = `${process.env.REACT_APP_API_URL}/doc/document/BANKING?documentType=${documentType}&connectionId=${connectionId}`;
  return getApi(url, {
    responseType: "blob",
  });
};

export const getViewDocumentHistory = (connectionId) => {
  const url = `${process.env.REACT_APP_API_URL}/doc/document/BANKING?connectionId=${connectionId}`;
  return getApi(url);
};

export const getTermsDoc = (docId) => {
  const url = `${process.env.REACT_APP_API_URL}/doc/document/get/${docId}`;
  return getApi(url);
};

export const getBankingArchive = (status, currentPage = 0, size = 10) => {
  const url = `${
    process.env.REACT_APP_API_URL
  }/banking/archive/list?status=${status.toUpperCase()}&currentPage=${currentPage}&size=${size}`;
  return getApi(url);
};
